import styled from '@emotion/styled';

export const DeliverySummaryWrapper = styled.div(({ theme }) => ({
    marginBottom: theme.space[4],
}));

export const Title = styled.div(({ theme }) => ({
    display: 'flex',
    marginBottom: theme.space[1],
    flexDirection: 'row',

    svg: {
        padding: 0,
        marginLeft: 0,
    },
}));
